import { Box } from "styles/globalComponents";
import { Loading } from "Utils/Loading";
import { Pagination } from "Components/Pagination";
import { useProducts } from "Hooks/useProducts";
import { useItemsContext } from "../../hooks/useItemsContext";
import { PreOrderFilters } from "../Filters";
import { ProductsListResult } from "../ProductResultList";
import { Container } from "../../styles";

export const ChooseProducts = () => {
  const {
    fetchNewPage,
    loadingProducts,
    pageSelected,
    productsList,
    productsPagination,
    handleClearData,
    setProductFilters,
  } = useProducts({
    initialFilters: {
      categories: "1,2,3",
      services: "1",
    },
    enableReq: true,
  });

  const { blockUserInteraction } = useItemsContext();

  return (
    <Container>
      <h5 className="title-search-products-budget">
        Buscar produtos Testes,Exames ou Check-ups
      </h5>

      <PreOrderFilters
        getProducts={setProductFilters}
        fetchNewPage={fetchNewPage}
        clearFetchedData={handleClearData}
      />

      {loadingProducts ? (
        <Box mt="30">
          <Loading />
        </Box>
      ) : (
        <div
          className={`cart-flex-products ${
            blockUserInteraction ? "blocked" : ""
          } `}
        >
          {!productsList && !loadingProducts && (
            <p className="text-danger text-display text-center text-no-margin">
              Oops! Nenhum produto encontrado...
            </p>
          )}

          {productsList && productsList?.length >= 1 && (
            <>
              <ProductsListResult productsList={productsList} />

              {productsPagination?.total_pages &&
                productsPagination.total_pages > 1 && (
                  <Box mt="20" pb="20">
                    <Pagination
                      pageLimit={1}
                      pageNeighbours={2}
                      totalRecords={productsPagination?.total_pages}
                      currentPageSelected={pageSelected}
                      onPageChanged={(pageObject) => {
                        if (blockUserInteraction) return;
                        fetchNewPage(pageObject.currentPage);
                      }}
                    />
                  </Box>
                )}
            </>
          )}
        </div>
      )}
    </Container>
  );
};
